import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getTranslation, type CustomTFunction, type TranslationResult } from './utils';

type CustomTranslation<TRoot, T extends string> = {
  readonly t: CustomTFunction<TRoot>;
  readonly tWrapper: TranslationResult<TRoot, T>;
};

export const createUseTranslation =
  <TRoot>() =>
  <T extends string>(base: T): CustomTranslation<TRoot, T> => {
    const { t } = useTranslation();

    return useMemo(() => {
      return {
        t: t as CustomTFunction<TRoot>,
        tWrapper: getTranslation<TRoot, T>(t, base),
      };
    }, [t, base]);
  };
